export enum PAYMENT_TYPE {
  FIX_AMOUNT = 0,
  FIXED_PERCENTAGE = 1,
}
